<template>
    <div class="indicator">
      <svg width="124px" height="77px" viewBox="0 0 124 77" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>wyrld-path</title>
        <g id="wyrld-path" class="stroke" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M10.8305564,15.915 C7.16089275,30.2173295 2.2323753,66.5711354 27.0235684,69.2926606 C52.3833146,72.0766003 52.3833146,38.2440334 51.7645195,23.573 C52.6240636,43.3016666 56.8294895,67.6825369 76.0044955,69.2926606 C102.964233,71.5564675 117.41971,8.20818924 91.2972564,7.74005682 C79.0130483,7.51991532 73.8652139,31.3006163 91.1416687,38.2057063 C98.4389281,41.1222904 106.518314,40.1055161 121.100456,35.53125" id="Path-2" stroke="currentColor" stroke-width="14.8"></path>
        </g>
      </svg>
    </div>
</template>

<style scoped>
.indicator {
  position: relative;
  margin: 100px auto;
}

.stroke {
  stroke-dasharray: 340;
  stroke-dashoffset: 340;
  animation: strokedraw 2.4s linear infinite;
}

@keyframes strokedraw {
   to {
    stroke-dashoffset: -340;
  }
}
</style>